import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import StyledDataGrid from '../../../components/StyledDataGrid';
import WorkspacePage from '../../../components/WorkspacePage';

const BioBankBioSpecimenChain = () => {
  const [rows] = useState([
    { id: 1, bioSpecimenID: 'B001', bioBankID: 'BB001', type: 'Blood', source: 'Patient A', collectionDate: '2023-03-10', storageLocation: 'Lab A', freezer: 'F1', rack: 'R2', box: 'BX5', position: 'P10', quantity: 5, quality: 'High', status: 'Stored' },
    { id: 2, bioSpecimenID: 'B002', bioBankID: 'BB002', type: 'Tissue', source: 'Patient B', collectionDate: '2023-05-22', storageLocation: 'Lab B', freezer: 'F2', rack: 'R3', box: 'BX2', position: 'P5', quantity: 3, quality: 'Medium', status: 'Processing' },
  ]);

  const columns = [
    { field: 'bioSpecimenID', headerName: 'BioSpecimen ID', flex: 1 },
    { field: 'bioBankID', headerName: 'BioBank ID', flex: 1 },
    { field: 'type', headerName: 'Type', flex: 1 },
    { field: 'source', headerName: 'Source', flex: 1 },
    { field: 'collectionDate', headerName: 'Collection Date', flex: 1 },
    { field: 'storageLocation', headerName: 'Storage Location', flex: 1 },
    { field: 'freezer', headerName: 'Freezer', flex: 1 },
    { field: 'rack', headerName: 'Rack', flex: 1 },
    { field: 'box', headerName: 'Box', flex: 1 },
    { field: 'position', headerName: 'Position', flex: 1 },
    { field: 'quantity', headerName: 'Quantity', flex: 1 },
    { field: 'quality', headerName: 'Quality', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
  ];

  return (
    <WorkspacePage>
      <PageHeader
        title="BioBank BioSpecimen Chain"
        actions={<Button variant="outlined">Add Data</Button>}
      />
      <Box sx={{ flex: 1, minHeight: 0, width: '100%', overflowX: 'auto' }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
          pagination
          autoHeight
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f5f5f5' },
          }}
        />
      </Box>
    </WorkspacePage>
  );
};

export default BioBankBioSpecimenChain;
